import { jsxs as w, jsx as m } from "react/jsx-runtime";
import { c as D } from "./index-65016bfa.mjs";
import A, { css as b } from "styled-components";
import "@fcamna/shared-component-foundations";
import { useRef as g } from "react";
import { u as J } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { H as Y, I as l } from "./helperText-d9646f54.mjs";
import { u as Z } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import { u as z } from "./uniqueId-321287e8.mjs";
import { L as x } from "./label-33699561.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "react-dom";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./button.js";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
const C = A.label`
  &.RadioButton-wrapper {
    ${({
  theme: {
    components: { radio: o }
  }
}) => b(o.RadioWrapper)}
  }
`, oo = A.input`
  &.RadioButton {
    ${({
  theme: {
    components: { radio: o }
  }
}) => b(o.RadioButton)}
  }
`, to = A.div`
  &.RadioButton__label {
    ${({
  theme: {
    components: { radio: o }
  }
}) => b(o.Label)}
  }
`, ao = "RADIO_DATA_TEST_ID", io = "RADIO_WRAPPER_DATA_TEST_ID", X = ({
  size: o = "small",
  checked: d,
  label: p,
  error: s = !1,
  helperText: I,
  description: r = I,
  horizontal: $,
  disabled: e,
  id: c,
  name: T,
  key: B,
  onChange: n,
  onClick: t,
  value: u,
  className: G,
  dataTestId: N = ao,
  accessibilityOptions: S = {},
  required: y = !1,
  inputRef: _,
  ...E
}) => {
  const L = J({ label: "Radio" }), P = Z("radio", S), R = c || z("Radio");
  return /* @__PURE__ */ w(
    C,
    {
      className: D(["RadioButton-wrapper", G]),
      "data-testid": io,
      ...L,
      children: [
        /* @__PURE__ */ m(
          oo,
          {
            "aria-disabled": e,
            "aria-checked": d,
            "aria-label": typeof p == "string" && p || void 0,
            "aria-describedby": r ? `${c}-helper-text` : void 0,
            ...P,
            ...E,
            id: R,
            name: T ?? c,
            "data-testid": N,
            type: "radio",
            value: u,
            error: s,
            checked: d,
            disabled: e,
            required: d === !0 ? y : !1,
            "aria-required": d === !0 ? y : !1,
            onChange: (a) => n == null ? void 0 : n(u, a),
            onClick: (a) => t == null ? void 0 : t(a, u),
            className: D([
              "RadioButton",
              `RadioButton--${o}`,
              {
                "RadioButton--error": s
              }
            ]),
            ref: _
          }
        ),
        /* @__PURE__ */ w(
          to,
          {
            className: D([
              "RadioButton__label",
              `RadioButton__label--${o}`,
              {
                "RadioButton__label--disabled": e,
                "RadioButton__label--horizontal": $,
                "RadioButton__label--vertical": !$
              }
            ]),
            children: [
              p,
              r && /* @__PURE__ */ m(Y, { defaultProp: { id: `${R}-helper-text`, helperText: r } })
            ]
          }
        )
      ]
    },
    B
  );
}, ro = A.fieldset`
  &.RadioGroup__fieldset {
    ${({
  theme: {
    components: { radio: o }
  }
}) => b(o.RadioGroupFieldSet)}
  }
`, so = A.div`
  &.RadioGroup {
    ${({
  theme: {
    components: { radio: o }
  }
}) => b(o.RadioGroup)}
  }
`, po = "RADIO_GROUP_DATA_TEST_ID", q = "RadioGroup", Ho = ({
  size: o = "small",
  children: d = [],
  horizontal: p,
  value: s,
  defaultValue: I = s,
  onChange: r,
  onBlur: $,
  error: e,
  label: c,
  helperText: T,
  required: B = !1,
  className: n,
  helperTextProp: t,
  dataTestId: u = po,
  inputState: G,
  name: N,
  inputRef: S
}) => {
  var U, W;
  const y = J({ label: "Radio Group" }), _ = g(z(q)), E = `${_.current}_label_id`, L = N || `${_.current}_name`, P = [].concat(d);
  let R = t, a = G || l.NONE;
  const V = Z("radiogroup", {
    ariaInvalid: e,
    ariaLabel: c,
    ariaLabelledBy: E,
    ariaDescribedBy: ((U = t == null ? void 0 : t.defaultProp) == null ? void 0 : U.id) || ((W = t == null ? void 0 : t.secondaryProp) == null ? void 0 : W.id) || `${a === l.ERROR ? "invalid" : "valid"}_${q}_helperText`
  });
  return G || (a = e ? l.ERROR : l.NONE), t ? R = {
    ...t,
    secondaryProp: {
      ...t.secondaryProp,
      state: a
    }
  } : R = {
    [a === l.ERROR ? "secondaryProp" : "defaultProp"]: {
      helperText: T,
      id: `${a === l.ERROR ? "invalid" : "valid"}_${q}_helperText`,
      state: a
    }
  }, /* @__PURE__ */ w(
    ro,
    {
      "data-testid": u,
      ...V,
      className: D(["RadioGroup__fieldset", "RadioGroup__fieldset--legend", n]),
      ...y,
      children: [
        /* @__PURE__ */ m(
          x,
          {
            renderAs: "legend",
            labelProp: {
              id: E,
              htmlFor: _.current,
              label: c,
              showRequiredIndicator: B
            }
          }
        ),
        /* @__PURE__ */ m(
          so,
          {
            className: D([
              "RadioGroup",
              `RadioGroup--${o}`,
              {
                "RadioGroup--horizontal": p,
                "RadioGroup--vertical": !p
              }
            ]),
            children: P.filter(Boolean).map(
              (i, v) => {
                var j, H, M, h, k, K;
                return i.type === X ? /* @__PURE__ */ m(
                  X,
                  {
                    dataTestId: `${u}_RADIO_BUTTON_${v + 1}`,
                    ...i.props,
                    name: ((j = i.props) == null ? void 0 : j.name) ?? L,
                    required: B,
                    defaultChecked: typeof I < "u" ? ((H = i.props) == null ? void 0 : H.value) === I : (M = i.props) == null ? void 0 : M.defaultChecked,
                    checked: typeof s < "u" ? ((h = i.props) == null ? void 0 : h.value) === s : (k = i.props) == null ? void 0 : k.checked,
                    onChange: r,
                    onBlur: $,
                    onKeyDown: (f) => {
                      var O, Q;
                      if (!s && (f.code === "Enter" || f.code === "Space")) {
                        const F = f.target;
                        F.checked = !0, (Q = (O = i.props) == null ? void 0 : O.onClick) == null || Q.call(O, F.value, f), r == null || r(F.value, f);
                      }
                    },
                    error: a === "error" || i.props.error,
                    inputRef: v === 0 ? S : void 0
                  },
                  ((K = i.props) == null ? void 0 : K.label) ?? v
                ) : i;
              }
            )
          }
        ),
        /* @__PURE__ */ m(Y, { ...R })
      ]
    }
  );
};
export {
  X as Radio,
  Ho as RadioList
};
